module.exports = __webpack_public_path__ + "img/SC.f70b5ea4.png";